import { Placement } from '@floating-ui/react';
import { Dayjs } from 'dayjs';

export type CalendarDate = Dayjs & {
  today: boolean;
  active: boolean;
  off: boolean;
  disabled: boolean;
};

export enum PanelView {
  Calendar,
  Month,
  Year,
}

export type PanelState = Record<'previous' | 'next', PanelView>;

export type PlacementType = 'auto' | Placement | undefined;

export type CalendarState = {
  previous: Dayjs;
  next: Dayjs;
  year: {
    previous: number;
    next: number;
  };
  months: string[];
};

export type CalendarObj = {
  date: () => CalendarDate[];
  month: string;
  year: number;
  years: () => number[];
  onPrevious: () => void;
  onNext: () => void;
  onPreviousYear: () => void;
  onNextYear: () => void;
  openMonth: () => void;
  setMonth: (key: number) => void;
  openYear: () => void;
  setYear: (val: number) => void;
};

export type DatePickerFormatter = {
  date: string;
  month: string;
};
